import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { reorderInventoryItemService } from '../services/reorderInventoryItemService';
import { ReorderInventoryItemSchema } from '../types/ReorderInventoryItemSchema';

const initialState: ReorderInventoryItemSchema = {
    isEditFlow: false,
    isEditFlowFromCategories: false,
    isSwap: false,
};

export const ReorderInventoryItemSlice = createSlice({
    name: 'ReorderInventoryItem',
    initialState,
    reducers: {
        setEditFlow: (state, action: PayloadAction<boolean>) => {
            state.isEditFlow = action.payload;
        },
        setInventoryOrderSwap: (state, action: PayloadAction<boolean>) => {
            state.isSwap = action.payload;
        },
        setEditFlowFromCategories: (state, action: PayloadAction<boolean>) => {
            state.isEditFlowFromCategories = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(reorderInventoryItemService.pending, (state) => {
                state.error = undefined;
                state.isLoading = true;
            })
            .addCase(reorderInventoryItemService.fulfilled, (state) => {
                state.isLoading = false;
                toast('Items reordered');
            })
            .addCase(reorderInventoryItemService.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            });
    },
});

export const { actions: reorderInventoryItemActions } =
    ReorderInventoryItemSlice;
export const { reducer: reorderInventoryItemReducer } =
    ReorderInventoryItemSlice;
